type NameLabelList = {
  [index: string]: string
}

export const TxTypes = {
  Types: {
    send: 'Send',
    set_leverage: 'Set Leverage',
    create_order: 'Create Order',
    delegate: 'Delegate',
    cancel_order: 'Cancel Order',
    update_profile: 'Update Profile',
    create_validator: 'Create Validator',
    initiate_liquidation: 'Initiate Liquidation',
    create_oracle_vote: 'Create Oracle Vote',
    mint_token: 'Mint Token',
    edit_validator: 'Edit Validator',
    vote: 'Vote',
    withdraw_validator_commission: 'Withdraw Validator Commission',
    activate_sub_account: 'Activate Sub-account',
    unjail: 'Unjail',
    withdraw_delegator_reward: 'Withdraw Delegator Reward',
    create_sub_account: 'Create Sub-account',
    deposit: 'Deposit',
    submit_proposal: 'Submit Proposal',
  } as NameLabelList,
} as const

export const OrderTypes = {
  Status: {
    cancelled: 'Cancelled',
    filled: 'Filled',
  } as NameLabelList,
} as const

export const ProposalTypes = {
  Topics: {
    authentication: 'Authentication',
    auth: 'Authentication',
    bank: 'Bank',
    distribution: 'Distribution',
    governance: 'Governance',
    gov: 'Governance',
    mint: 'Mint',
    slashing: 'Slashing',
    staking: 'Staking',
  } as NameLabelList,
  Parameters: {
    MaxMemoCharacters: 'Max Memo Characters',
    TxSigLimit: 'Tx Sig Limit',
    TxSizeCostPerByte: 'Tx Size Cost Per Byte',
    SigVerifyCostED25519: 'Sig Verify Cost ED25519',
    SigVerifyCostSecp256k1: 'Sig Verify Cost secp256k1',
    sendenabled: 'Send Enabled',
    'depositparams-min_deposit': 'Min Deposit',
    'depositparams-max_deposit_period': 'Max Deposit Period',
    'votingparams-voting_period': 'Voting Period',
    'tallyparams-quorum': 'Quorum (Tally Parameter)',
    'tallyparams-threshold': 'Pass Threshold (Tally Parameter)',
    'tallyparams-veto': 'Veto Threshold (Tally Parameter)',
    communitytax: 'Community Tax',
    baseproposerreward: 'Base Proposer Reward',
    bonusproposerreward: 'Bonus Proposer Reward',
    withdrawaddrenabled: 'Withdraw Address Enabled',
    SignedBlocksWindow: 'Signed Blocks Window',
    MinSignedPerWindow: 'Min Signed Per Window',
    DowntimeJailDuration: 'Downtime Jail Duration',
    SlashFractionDoubleSign: 'Slash Fraction Double Sign',
    SlashFractionDowntime: 'Slash Fraction Downtime',
    UnbondingTime: 'Unbonding Time',
    MaxValidators: 'Max Validators',
    KeyMaxEntries: 'Key Max Entries',
    HistoricalEntries: 'Historical Entries',
  } as NameLabelList,
} as const

export const BlockChainMap: { [key: string]: string } = {
  eth: 'Ethereum',
  neo: 'Neo',
  swth: 'Switcheo',
  zil: 'Zilliqa',
  bsc: 'Binance Smart Chain',
}

export const TaskNames = {
  App: {
    InitializeSDK: 'initialize-sdk',
    GeckoCoin: 'gecko-coin-app',
    InsuranceSupply: 'insurance-supply-app',
    Markets: 'markets-app',
    NeoPrice: 'neo-price-app',
    Oracles: 'oracles-app',
    SigningInfo: 'signing-info-app',
    StakingPool: 'staking-pool-app',
    SwthSupply: 'swth-supply-app',
    TotalSupply: 'total-supply-app',
    Validators: 'validators-app',
    LatestBlock: 'latest-block-app',
  },
  Account: {
    Delegations: 'delegations-account',
    ExternalTransfers: 'external-transfers-account',
    Holdings: 'holdings-account',
    OpenOrdersFilter: 'open-order-filter-account',
    OpenOrders: 'open-orders-account',
    OrderFilter: 'order-filter-account',
    OrderList: 'order-list-account',
    Positions: 'positions-account',
    PositionsFilter: 'positions-filter-account',
    PositionsHistory: 'positions-history-account',
    PositionsHistoryFilter: 'positions-history-filter-account',
    Profile: 'profile-account',
    Rewards: 'rewards-account',
    TradesFilter: 'trades-filter-account',
    TradesByAccount: 'trades-by-account',
    TransactionFilter: 'transaction-filter-account',
    Transactions: 'transactions-account',
    TransactionType: 'transaction-type-account',
  },
  Blocks: {
    List: 'blocks-component',
    Filter: 'blocks-filter-component',
  },
  Block: {
    Transaction: 'transaction-block',
    Info: 'info-block',
    Events: 'events-block',
  },
  Dashboard: {
    Blocks: 'blocks-dashboard',
    BlockTime: 'blocktime-dashboard',
    MarketStats: 'market-stats-dashboard',
    Transactions: 'transactions-dashboard',
    Wallets: 'wallets-dashboard',
    Distribution: 'distribution-dashboard',
    Apr: 'apr-dashboard',
  },
  Events: {
    LEOrderFilter: 'le-order-filter-events',
    LEOrders: 'le-orders-events',
    LETrades: 'le-trades-events',
    SettledMarkets: 'settled-markets-events',
  },
  Governance: {
    DepositParams: 'deposit-params-governance',
    Delegations: 'delegations-governance',
    DepositHistory: 'deposit-history-governance',
    Proposals: 'proposals-governance',
    TallyParams: 'tally-params-governance',
    VoteHistory: 'vote-history-governance',
  },
  Market: {
    Detail: 'detail-market',
    OrderFilter: 'order-filter-market',
    OrderList: 'order-list-market',
    ProfitableFilter: 'profitable-filter-market',
    ProfitablePositions: 'profitable-positions-market',
    LargeFilter: 'large-filter-market',
    LargePositions: 'large-positions-market',
    LongRisky: 'long-risky-market',
    LongRiskyFilter: 'long-risky-filter-market',
    ShortRisky: 'short-risky-market',
    ShortRiskyFilter: 'short-risky-filter-market',
    Stats: 'stats-market',
    TopProfits: 'top-profits-market',
    TradeFilter: 'trade-filter-market',
    TradeList: 'trade-list-market',
  },
  Leaderboard: {
    D30: '30days-leaderboard',
    Lifetime: 'lifetime-leaderboard',
    D30Filters: 'days-30-filters',
    LifetimeFilters: 'lifetime-filters',
  },
  LeaderboardHistory: {
    leaderboard: 'leaderboard',
  },
  Markets: {
    OrderFilter: 'order-filter-markets',
    Orders: 'orders-markets',
    TradeFilter: 'trade-filter-markets',
    Trades: 'trades-markets',
    MarketStats: 'stats-markets'
  },
  Nodes: {
    List: 'list-nodes',
  },
  Order: {
    Detail: 'detail-order',
    TradesByAccount: 'trades-by-account',
  } as NameLabelList,
  Position: {
    Detail: 'detail-position',
  } as NameLabelList,
  Pools: {
    List: 'list-pools',
    RewardCurve: 'reward-curve-pools',
    CommitmentCurve: 'commitment-curve-pools',
  },
  Token: {
    Detail: 'detail-token',
    RichList: 'rich-list-token',
  },
  Tokens: {
    CirculateSupply: 'circulate-supply-tokens',
    Info: 'info-tokens',
  },
  Transaction: {
    Detail: 'detail-transaction',
    Log: 'log-transaction',
  },
  Transactions: {
    Filter: 'filter-transactions',
    List: 'list-transactions',
    Types: 'types-transactions',
  },
  Validator: {
    Blocks: 'blocks-validator',
    BlocksFilter: 'blocks-filter-validator',
    Detail: 'detail-validator',
    Delegations: 'delegations-validator',
  },
  Validators: {
    BlockTime: 'block-time-validators',
    Distribution: 'distribution-validators',
    List: 'list-validators',
    Slashing: 'slashing-validators',
  },
} as const

export const FuturesDenomOverride = {
  WBTC: 'BTC',
  USDC: 'USD',
}

export const FuturesNameOverride: {
  [key: string]: string
} = {
  'Wrapped BTC': 'Bitcoin',
}
